/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


document.addEventListener('click', function(event) {
  const btn = event.target.closest('[data-button-quick-view]');
  if (btn) {
    window.__lastQuickViewTrigger = btn;
  }
}, true);

(function() {
  function normalizeMoneyString(str) {
    return String(str || '')
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;|&#160;/g, '\u00A0')
      .trim();
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = isNaN(precision) ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';

    const n = (Number(number) / 100).toFixed(precision);
    const parts = n.split('.');
    const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    const cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }

  function formatMoneyFallback(cents, format) {
    let value = '';
    const fmt = format || '{{amount}}';
    const match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const token = match ? match[1] : 'amount';

    switch (token) {
      case 'amount':
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', '.');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }

    return fmt.replace(match ? match[0] : '{{amount}}', value);
  }

  function formatMoney(cents, currencyCodeEnable, moneyFormat, moneyWithCurrencyFormat) {
    const c = Number(cents || 0);
    const format = currencyCodeEnable ? moneyWithCurrencyFormat : moneyFormat;

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return normalizeMoneyString(window.Shopify.formatMoney(c, format));
      } catch (e) {}
    }

    return normalizeMoneyString(formatMoneyFallback(c, format));
  }

  function getPopupHandle(root) {
    const titleLink = root.closest('.popup-quick-view')?.querySelector('.popup-quick-view__title a[href*="/products/"]');
    if (!titleLink) return '';

    const href = titleLink.getAttribute('href') || '';
    const match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function parsePercentFromCard(card) {
    if (!card) return 0;

    const savingBadge = card.querySelector('.product__badge__item--saving span');
    if (!savingBadge) return 0;

    const text = savingBadge.textContent || '';
    const match = text.match(/(\d+)/);
    return match ? parseInt(match[1], 10) || 0 : 0;
  }

  function getTriggerForHandle(handle) {
    if (!handle) return null;

    if (
      window.__lastQuickViewTrigger &&
      window.__lastQuickViewTrigger.getAttribute &&
      window.__lastQuickViewTrigger.getAttribute('data-handle') === handle
    ) {
      return window.__lastQuickViewTrigger;
    }

    return document.querySelector('[data-button-quick-view][data-handle="' + handle + '"]');
  }

  function getFallbackDiscountPercent(root) {
    const handle = getPopupHandle(root);
    const trigger = getTriggerForHandle(handle);
    const card =
      trigger?.closest('.product-grid-item') ||
      trigger?.closest('[data-product-block]') ||
      trigger?.closest('.grid__item') ||
      null;

    return parsePercentFromCard(card);
  }

  function findVariantById(variants, id) {
    const numericId = Number(id || 0);
    if (!numericId) return null;
    return variants.find(function(variant) {
      return Number(variant.id) === numericId;
    }) || null;
  }

  function getCurrentVariant(root, variants) {
    const popup = root.closest('.popup-quick-view') || document;
    const idInput =
      popup.querySelector('form[action*="/cart/add"] [name="id"]') ||
      popup.querySelector('[name="id"]');

    if (!idInput) return variants[0] || null;
    return findVariantById(variants, idInput.value) || variants[0] || null;
  }

  function getEffectiveDiscountPercent(root) {
    const attrPercent = Number(root.getAttribute('data-collection-discount-percent') || 0);
    if (attrPercent > 0 && attrPercent < 100) return attrPercent;

    const fallbackPercent = getFallbackDiscountPercent(root);
    if (fallbackPercent > 0 && fallbackPercent < 100) return fallbackPercent;

    return 0;
  }

  function getDiscountedState(variant, discountPercent, useProductCompareAt) {
    const rawPrice = Number((variant && variant.price) || 0);
    const rawCompare = Number((variant && variant.compare_at_price) || 0);

    if (useProductCompareAt && rawCompare > rawPrice && rawCompare > 0) {
      return {
        price: rawPrice,
        compare: rawCompare,
        onSale: true
      };
    }

    const discountedPrice = Math.round(rawPrice * (100 - discountPercent) / 100);

    return {
      price: discountedPrice,
      compare: rawPrice,
      onSale: rawPrice > discountedPrice
    };
  }

  function applyQuickViewCollectionDiscount(root) {
    if (!root) return;

    const discountEnabled = root.getAttribute('data-collection-discount-enabled') === 'true';
    if (!discountEnabled) return;

    const discountPercent = getEffectiveDiscountPercent(root);
    if (!(discountPercent > 0 && discountPercent < 100)) return;

    const useProductCompareAt = root.getAttribute('data-use-product-compare-at') === 'true';
    const currencyCodeEnable = root.getAttribute('data-currency-code-enable') === 'true';
    const savingBadgeType = root.getAttribute('data-saving-badge-type') || 'percentage';

    const variantsJsonEl = root.querySelector('[data-variants-json]');
    if (!variantsJsonEl) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsJsonEl.textContent || '[]');
    } catch (e) {
      variants = [];
    }
    if (!variants.length) return;

    const productPriceEl = root.querySelector('[data-product-price]');
    const comparePriceEl = root.querySelector('[data-compare-price]');
    const priceOffWrap = root.querySelector('[data-price-off]');
    const priceOffType = root.querySelector('[data-price-off-type]');
    const priceOffAmount = root.querySelector('[data-price-off-amount]');
    if (!productPriceEl) return;

    const variant = getCurrentVariant(root, variants);
    if (!variant) return;

    const freeText = 'Free';
    const saleText = root.querySelector('[data-price-off-type]')?.textContent?.trim() || 'Sale';
    const moneyFormat = JSON.parse(root.getAttribute('data-money-format') || '""');
    const moneyWithCurrencyFormat = JSON.parse(root.getAttribute('data-money-with-currency-format') || '""');

    const state = getDiscountedState(variant, discountPercent, useProductCompareAt);
    const diff = Math.max(0, state.compare - state.price);
    const diffPercent = state.compare > 0 ? Math.floor((diff / state.compare) * 100) : 0;

    productPriceEl.textContent = state.price === 0
      ? freeText
      : formatMoney(state.price, currencyCodeEnable, moneyFormat, moneyWithCurrencyFormat);

    productPriceEl.classList.toggle('product__price--sale', state.onSale);

    if (comparePriceEl) {
      comparePriceEl.textContent = state.onSale
        ? formatMoney(state.compare, currencyCodeEnable, moneyFormat, moneyWithCurrencyFormat)
        : '';
      comparePriceEl.classList.toggle('hidden', !state.onSale);
    }

    if (priceOffWrap && priceOffType && priceOffAmount) {
      if (state.onSale) {
        priceOffType.textContent = saleText;
        priceOffAmount.textContent = savingBadgeType === 'percentage'
          ? String(diffPercent) + '%'
          : formatMoney(diff, currencyCodeEnable, moneyFormat, moneyWithCurrencyFormat);
        priceOffWrap.classList.remove('hidden');
      } else {
        priceOffAmount.textContent = '';
        priceOffWrap.classList.add('hidden');
      }
    }
  }

  function applyAllQuickViewDiscounts() {
    document.querySelectorAll('.popup-quick-view [data-qv-collection-discount]').forEach(function(root) {
      applyQuickViewCollectionDiscount(root);
    });
  }

  document.addEventListener('theme:popup:open', function() {
    setTimeout(applyAllQuickViewDiscounts, 0);
    setTimeout(applyAllQuickViewDiscounts, 80);
    setTimeout(applyAllQuickViewDiscounts, 180);
  });

  document.addEventListener('theme:variant:change', function(event) {
    const popup = event.target && event.target.closest ? event.target.closest('.popup-quick-view') : null;
    if (!popup) return;

    const root = popup.querySelector('[data-qv-collection-discount]');
    if (!root) return;

    setTimeout(function() {
      applyQuickViewCollectionDiscount(root);
    }, 0);

    setTimeout(function() {
      applyQuickViewCollectionDiscount(root);
    }, 80);

    setTimeout(function() {
      applyQuickViewCollectionDiscount(root);
    }, 180);
  }, true);

  document.addEventListener('change', function(event) {
    if (!event.target.closest('.popup-quick-view')) return;
    setTimeout(applyAllQuickViewDiscounts, 0);
  }, true);
})();






// translate "buy it now" for uk

 (function () {
        
        function isUA() {
          var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
          return lang.startsWith('uk'); 
        }

        function applyUAButtonText() {
          if (!isUA()) return;

          var btns = document.querySelectorAll('.shopify-payment-button__button--unbranded');
          btns.forEach(function (btn) {
          
            var desired = 'КУПИТИ';
            if (btn.textContent.trim() !== desired) {
              btn.textContent = desired;
              btn.setAttribute('aria-label', 'Купити зараз');
            }
          });
        }


        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', applyUAButtonText);
        } else {
          applyUAButtonText();
        }

        
        var mo = new MutationObserver(function (mutations) {
          var shouldRun = false;
          for (var i = 0; i < mutations.length; i++) {
            if (mutations[i].type !== 'childList') continue;
            var nodes = mutations[i].addedNodes;
            for (var j = 0; j < nodes.length; j++) {
              var n = nodes[j];
              if (n.nodeType !== 1) continue;
              if ((n.matches && n.matches('.shopify-payment-button__button--unbranded')) ||
                  (n.querySelector && n.querySelector('.shopify-payment-button__button--unbranded'))) {
                shouldRun = true; break;
              }
            }
            if (shouldRun) break;
          }
          if (shouldRun) applyUAButtonText();
        });

        if (document.body) {
          mo.observe(document.body, { childList: true, subtree: true });
        } else {
        
          document.addEventListener('DOMContentLoaded', function(){ 
            mo.observe(document.body, { childList: true, subtree: true });
          });
        }

        document.addEventListener('shopify:section:load', applyUAButtonText);
      })();


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
